import React, { useState, useEffect, useRef,forwardRef, useImperativeHandle } from "react";
import DragAndDropFileUpload from "./DragAndDropFileUpload";

const RequestServiceAttachment = forwardRef((props, ref) => {

    /*state declarations */
    const [uploadedSRFilesRows, setUploadedSRFilesRows] = useState([]);

     /*ref declaration*/
    const ClearAttachmentError = useRef(null);

    useEffect(() => {
        props.childAttachmentClearFunc.current = ClearAttachmentsAfterSave;
    }, [])

    useImperativeHandle(ref, () => ({
        LoadFilesList(files) {
            setServiceRequestFilesList(files)
            SetServiceRequestFile(files)
        },
        ClearError(){
            ClearAttachmentError.current();
        }
    }));

    const ClearAttachmentsAfterSave = () => {
        setUploadedSRFilesRows([]);
        ClearAttachmentError.current();
    }

    const onDelete = (fileName) => {
        let SRFilesRowAfterDelete = uploadedSRFilesRows.filter(el => el.filename !== fileName);
        //let SRFilesAfterDelete = uploadedSRFiles.filter(el => el.name !== fileName);
        //setUploadedSRFiles(FilesAfterDelete);

        props.UploadSRFile([]);
        setUploadedSRFilesRows(SRFilesRowAfterDelete);
        ClearAttachmentsAfterSave();
    }

    const onUpload = (filesList, callback, fileDesc) => {
        setTimeout(() => {
            callback && callback(true);
            setServiceRequestFilesList(filesList);
            SetServiceRequestFile(filesList);
        }, 1000);
    };

    const SetServiceRequestFile = (fileslst) => {
        const files = [];
        fileslst.forEach((file) => (
            files.push(file)
        ));
        //setUploadedSRFiles(files);
        props.UploadSRFile(files);
    }

    const setServiceRequestFilesList = (fileDetails) => {
        const files = [];
        let newlyAddedFiles = fileDetails.map((file) => {
            return {
                filename: file.name,
                filesize: bytesToSize(file.size),
                date: formatDate(new Date()),
            };
        });
        setUploadedSRFilesRows([...files, ...newlyAddedFiles]);
    };

    const formatDate = (date) => {
        const formattedDate = new Date(date).toDateString();
        return formattedDate;
    };

    const bytesToSize = (bytes) => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) return "0 Byte";
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    };

    return(
        <DragAndDropFileUpload
            acceptFileTypes={props.fileTypes}
            maxFileSize={props.fileSize} 
            hintText= {props.hintText} 
            onUpload={onUpload}
            uploadedFilesRows={uploadedSRFilesRows}
            onDelete={onDelete}
            ClearAttachmentError={ClearAttachmentError}
            numberofFiles={1}
            isDisabled={props.isDisabled}
        />
    )
});

export default RequestServiceAttachment;